import { useTranslation } from 'react-i18next'
import { UseRollupStatsParams, useRollupStats } from '@cibo/profile'
import { useFigures } from '@cibo/ui'
import { Grid, Stack, Typography } from '@mui/material'
import { pluck, sum, values } from 'ramda'

export const FDRRollups = (rollupParams: UseRollupStatsParams) => {
  const stats = useRollupStats(rollupParams)
  const { acres: formatAcres, earnedAmount } = useFigures()
  const { t: fieldsT } = useTranslation('impact/components/EnrollmentList')
  const { t: statusT } = useTranslation('@cibo/landmanager/ProgramStatusFilter')
  const { t: profileT } = useTranslation('@cibo/profile')

  return (
    <Grid columns={{ xs: 4, md: 8, lg: 12 }} spacing={3} container>
      {stats.data?.fdrStats.map(({ status, fields, acres, personaCounts, rewards }) => {
        const rewardDollars = rewards?.opportunities?.usd

        const userCount = personaCounts && sum(pluck('fields', values(personaCounts)))

        return (
          <Grid key={status} xs={4} item>
            <Stack spacing={1}>
              <Typography variant="h5">{statusT(status)}</Typography>

              <Grid columns={2} container>
                <Grid xs={1} item>
                  <Stack>
                    {!!rewardDollars && (
                      <Typography variant="body2">{earnedAmount(rewardDollars)}</Typography>
                    )}
                    {!!userCount && (
                      <Typography variant="caption">
                        {profileT('userCount', { count: userCount })}
                      </Typography>
                    )}
                  </Stack>
                </Grid>

                <Grid xs={1} item>
                  <Stack>
                    {!!acres && <Typography variant="body2">{formatAcres(acres)}</Typography>}
                    {!!fields && (
                      <Typography variant="caption">
                        {fieldsT('fields', { count: fields })}
                      </Typography>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
        )
      })}
    </Grid>
  )
}
